import { keyframes, styled } from 'styled-components'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
export const SpinnerImage = styled.img`
  animation: ${spin} 0.4s linear infinite;
  height: 100%;
  width: auto;
`
